/**
 * Текст пользовательского соглашения (перенесён дословно из удалённого src/components/UserAgreement.vue).
 * Формат: массив разделов { title, paragraphs }. Пункты списков сохранены как отдельные абзацы
 * с префиксом «• » (рендерить можно как обычные абзацы).
 */
export const AGREEMENT_TITLE = "Пользовательское соглашение об обработке персональных данных";

export const agreementSections = [
  {
    title: "1. Общие положения",
    paragraphs: [
      "1.1. Настоящее Пользовательское соглашение (далее — «Соглашение») регулирует порядок сбора, хранения, обработки и защиты персональных данных пользователей (далее — «Пользователь») на территории Российской Федерации.",
      "1.2. Используя приложение (далее — «Сервис»), Пользователь выражает свое согласие с условиями настоящего Соглашения.",
      "1.3. Обработка персональных данных осуществляется в соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных» и иными нормативными актами РФ.",
    ],
  },
  {
    title: "2. Состав персональных данных",
    paragraphs: [
      "2.1. Сервис может обрабатывать следующие данные Пользователя:",
      "• ФИО;",
      "• контактные данные (телефон);",
      "• данные учетной записи (IP-адрес, cookie-файлы);",
      "• иные данные, предоставленные Пользователем добровольно.",
    ],
  },
  {
    title: "3. Цели обработки персональных данных",
    paragraphs: [
      "3.1. Персональные данные обрабатываются для:",
      "• регистрации и идентификации Пользователя;",
      "• предоставления услуг Сервиса;",
      "• обработки заказов и платежей;",
      "• отправки уведомлений и рекламных материалов (с согласия Пользователя);",
      "• улучшения качества работы Сервиса;",
      "• выполнения требований законодательства РФ.",
    ],
  },
  {
    title: "4. Условия обработки и хранения данных",
    paragraphs: [
      "4.1. Обработка данных осуществляется с согласия Пользователя, которое выражается путем проставления соответствующей отметки при регистрации или использовании Сервиса.",
      "4.2. Данные хранятся на защищенных серверах на территории РФ в соответствии с ст. 18 ФЗ-152.",
      "4.3. Срок хранения данных — до достижения целей обработки или до отзыва согласия Пользователем.",
    ],
  },
  {
    title: "5. Передача данных третьим лицам",
    paragraphs: [
      "5.1. Сервис может передавать данные:",
      "• партнерам для исполнения обязательств (курьерским службам, платежным системам);",
      "• государственным органам по законному требованию;",
      "• иным лицам только с согласия Пользователя.",
    ],
  },
  {
    title: "6. Права Пользователя",
    paragraphs: [
      "6.1. Пользователь вправе:",
      "• запрашивать доступ, исправление или удаление своих данных;",
      "• отозвать согласие на обработку;",
      "• требовать прекращения обработки в случае нарушений.",
    ],
  },
  {
    title: "7. Защита данных",
    paragraphs: [
      "7.1. Сервис принимает технические и организационные меры для защиты данных от утраты, утечки и несанкционированного доступа.",
    ],
  },
  {
    title: "8. Заключительные положения",
    paragraphs: [
      "8.1. Настоящее Соглашение может быть изменено в одностороннем порядке с публикацией новой версии.",
      "8.2. Продолжение использования Сервиса означает принятие изменений.",
      "8.3. Споры разрешаются в соответствии с законодательством РФ.",
    ],
  },
];

export default agreementSections;
